import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Account } from 'app/shared/models/account';
import { map, Observable } from 'rxjs';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class NotMaintenanceGuard implements CanActivate {
  accountInfo: Account;

  constructor(private commonService: CommonService, private router: Router) { }

  canActivate(): Observable<boolean> {
    return this.commonService.getWebsiteMaintenanceStatus().pipe(
      map((maintenance: boolean) => {
        if (!maintenance) {
          const type = localStorage.getItem('account');
          if (type) {
            this.accountInfo = JSON.parse(type);
          }
          if (this.accountInfo.isSuperUser) {
            this.router.navigate(['/dashboard']);
            return false;
          }
          if (this.accountInfo.supervisorMode) {
            this.router.navigate(['/home']);
            return false;
          }
          if (!this.accountInfo.isSuperUser) {
            this.router.navigate(['/home']);
            return false;
          }
        }
        return true;
      })
    );
  }
}
